import React from "react";
import GeeTest from "react-geetest-v4";
import { Cookies } from "../shared/cookies.js";

const translationsLazy = {
  vi: {
    prompt: "Vui long xac nhan o duoi"
  },
  en: {
    prompt: "Please confirm below"
  }
};

function detectLang() {
  const fromCookie = String(Cookies.get("national_market") || "").trim().toLowerCase();
  if (fromCookie === "vi" || fromCookie === "en") return fromCookie;

  const fromLocal = String(localStorage.getItem("national_market") || "").trim().toLowerCase();
  if (fromLocal === "vi" || fromLocal === "en") return fromLocal;

  return "en";
}

function LazyGeeTest(props) {
  const lang = detectLang();
  const promptText =
    props.promptText || translationsLazy[lang]?.prompt || translationsLazy.en.prompt;

  return (
    <div className="mb-3 mt-1 items-center justify-between">
      {!props.geetoken && <div>{promptText}</div>}

      <div className="flex items-center justify-between">
        <div className="mx-auto">
          <GeeTest
            captchaId={props.captchaId}
            containerId={props.containerId}
            product={props.product || "bind"}
            onSuccess={(result) => props.handleGeetestSuccess(result)}
            onReady={() => {
              if (props.onReady) props.onReady();
              console.log("ready");
            }}
            ref={props.captchaRef}
          >
            {props.children}
          </GeeTest>
        </div>
      </div>
    </div>
  );
}

export default LazyGeeTest;
